import type { NewsItem } from "@/types/content";

export const newsList: NewsItem[] = [
  {
    id: "from-video-hall-to-streaming",
    title: "从录像厅到流媒体：三级片观影空间的三十年变迁",
    date: "2026-10-12",
    category: "行业观察",
    author: "编辑部",
    summary:
      "放映空间的变化，往往比影片本身更快地改写一代人的观影记忆。从街角录像厅到客厅里的投屏，我们梳理了三十年里观看方式的三次转折。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20vintage%20film%20reels%20and%20an%20old%20projector%20on%20a%20wooden%20table%20with%20warm%20lamplight%2C%20dust%20floating%20in%20the%20air%2C%20nostalgic%20mood%2C%20no%20text&width=800&height=500&seq=news-video-hall&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "上世纪九十年代，看一部电影是一件需要出门的事。街角的录像厅把票价压得很低，木椅、电风扇和一台画质并不稳定的电视，构成了那个年代最普遍的观影现场。观众彼此并不认识，却在同一块屏幕前共享两个小时的情绪。",
      },
      {
        type: "h2",
        text: "第一次转折：从公共空间回到客厅",
      },
      {
        type: "p",
        text: "影碟机普及之后，观影迅速从公共空间退回到家庭。内容的选择权第一次真正交到观众手上，快进、重看、暂停这些动作，改变了人们对叙事节奏的耐心。类型片开始被拆解成可以反复观看的片段。",
      },
      {
        type: "p",
        text: "也正是在这个阶段，影迷文化出现了明显分层：一部分观众开始关注导演、摄影和美术，另一部分观众只在意某一类场景。这两类需求同时推动了后来的资料站与修复市场。",
      },
      { type: "h2", text: "第二次转折：资料库取代了货架" },
      {
        type: "p",
        text: "当宽带进入普通家庭，影碟店的货架被数据库取代。人们不再依赖店主的推荐，而是通过标签、年份、地区去筛选作品。分类和检索能力，逐渐成为影视资料站最重要的基本功。",
      },
      {
        type: "quote",
        text: "观看方式改变了，但人们想弄明白「这部片子到底讲了什么」的冲动，从来没有变过。",
      },
      { type: "h2", text: "第三次转折：资料与观看分开" },
      {
        type: "p",
        text: "今天，越来越多的观众习惯先查资料再决定要不要看。影片的年份、地区、主创、类型标签，以及一段客观的简介，构成了新的入口。这也是本站坚持只做资料整理与资讯报道的原因：把选择权留给观众，把信息讲清楚。",
      },
      {
        type: "p",
        text: "三十年间，屏幕从街角搬进客厅，又搬进每个人的口袋。空间在缩小，但对一部作品的好奇心始终没有变。",
      },
    ],
  },
  {
    id: "neon-rain-restored",
    title: "修复版《霓虹夜雨》重登大银幕：一次关于光的再创作",
    date: "2026-10-08",
    category: "影片动态",
    author: "林一舟",
    summary:
      "修复团队用十四个月重新扫描原始底片，并逐帧调整雨夜场景的色温。导演陈可岚在映后谈中表示，这一次观众看到的是更接近当年拍摄现场的版本。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20an%20empty%20cinema%20hall%20with%20deep%20red%20velvet%20seats%20and%20warm%20screen%20glow%2C%20nostalgic%20atmosphere%2C%20no%20text&width=800&height=500&seq=news-cinema-hall&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "《霓虹夜雨》的原始底片在仓库里躺了将近三十年。修复项目启动时，团队面对的第一个问题是：要不要保留那些被时间留下的划痕。最终他们选择保留一部分，因为那些痕迹本身也是影片历史的一部分。",
      },
      { type: "h2", text: "把雨重新做出来" },
      {
        type: "p",
        text: "影片有超过六成的时间在下雨。老拷贝里的雨丝已经糊成一片灰白，修复过程中最难的部分不是清晰度，而是层次——要让人看清雨落下的方向，又不能让画面变得过于锐利而失去胶片感。",
      },
      {
        type: "quote",
        text: "我们不是在修一张照片，而是在恢复一种光的逻辑。",
      },
      {
        type: "p",
        text: "色温调整是另一个争议点。当年的拷贝偏青，但根据摄影指导留下的笔记，拍摄现场使用的其实是更暖的灯。修复版最终偏向紫与橙的对比，让霓虹在湿路面上显得更有重量。",
      },
      { type: "h2", text: "映后：关于「看完之后想做什么」" },
      {
        type: "p",
        text: "映后谈上，陈可岚提到自己最在意的一件事：观众散场之后会不会想再看一遍。她说修复不只是让老片重新上映，更是给年轻观众一次在大银幕上重新认识类型片的机会。",
      },
    ],
  },
  {
    id: "hong-kong-color-aesthetics",
    title: "类型片档案：九十年代港产三级片的色彩美学",
    date: "2026-09-28",
    category: "专题报道",
    author: "苏行",
    summary:
      "霓虹紫、钨丝灯的橙、旧墙的米黄——这批影片用极有限的预算，建立了一套辨识度极高的色彩语言。我们拆解了其中最常见的三种配色策略。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20a%20stack%20of%20old%20film%20canisters%20and%20handwritten%20notes%20on%20a%20desk%2C%20warm%20amber%20light%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=800&height=500&seq=news-film-canisters&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "如果把这批影片的截图排成一面墙，你会发现它们几乎共享同一套色板：紫、橙、米黄。这不是巧合，而是拍摄条件、胶片特性和美术选择共同作用的结果。",
      },
      { type: "h2", text: "策略一：用两种光区分两个世界" },
      {
        type: "p",
        text: "室内常用钨丝灯，肤色偏暖；室外则是霓虹与钠灯，紫与橙互相拉扯。人物从街上走进房间，画面温度会立刻改变。这种简单粗暴的对照，在预算有限的情况下极其有效。",
      },
      { type: "h2", text: "策略二：让墙面承担叙事" },
      {
        type: "p",
        text: "旧楼的水泥墙、剥落的油漆、泛黄的瓷砖，本身就是年代信息。美术部门常常只做一件事：把墙面处理到足够有质感，然后让摄影机贴近它拍摄。",
      },
      {
        type: "quote",
        text: "当布景没有钱的时候，墙就是最便宜也最诚实的道具。",
      },
      { type: "h2", text: "策略三：把荧光色留在画面边缘" },
      {
        type: "p",
        text: "紫色和橙色很少同时占据画面中心。更常见的做法是把它们放在画面的两条边上，中间留给人物。这样既保留了视觉冲击，又不会干扰表演。",
      },
      {
        type: "p",
        text: "这套方法论后来被大量沿用，也影响了不少当代类型片的调色思路。理解了配色，再看这些影片会发现信息量完全不同。",
      },
    ],
  },
  {
    id: "autumn-watchlist",
    title: "秋季片单：五部适合入门的剧情向作品",
    date: "2026-09-20",
    category: "编辑推荐",
    author: "编辑部",
    summary:
      "如果你刚开始接触这类影片，从叙事完整、节奏温和的作品入手会更容易。这份片单覆盖八十年代末到近年的五个选择，均可在站内查看详细资料。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20a%20film%20festival%20courtyard%20at%20dusk%20with%20string%20lights%20and%20warm%20haze%2C%20inviting%20atmosphere%2C%20no%20text&width=800&height=500&seq=news-autumn-list&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "入门片单的原则只有两个：故事讲得清楚，情绪不靠堆砌。以下五部作品在站内都有完整的资料页，可以先看简介再决定是否深入。",
      },
      { type: "h2", text: "一、《潮汐之间》：先看氛围" },
      {
        type: "p",
        text: "大量静止长镜头、极少的对白，适合想先感受画面节奏的观众。如果看完记住了潮水的声音，说明你已经进入这部片的状态。",
      },
      { type: "h2", text: "二、《落日车站》：先看人物" },
      {
        type: "p",
        text: "一个站台、两班车、二十年等待，结构简单但情感完整。它在叙事上几乎没有门槛。",
      },
      { type: "h2", text: "三、《长夜信箱》：先看结构" },
      {
        type: "p",
        text: "一个场景、两个人物，靠设定推进。看完可以想想：信到底是谁写的？这是这类小成本作品最有趣的地方。",
      },
      { type: "h2", text: "四、《潮汐城的信》：先看城市" },
      {
        type: "p",
        text: "旧街区与新建筑的交替出现，构成了另一条隐形的时间线。适合喜欢城市题材的观众。",
      },
      { type: "h2", text: "五、《白色回声》：给愿意戴上耳机的人" },
      {
        type: "p",
        text: "声音设计是这部片的主角。建议在安静的环境里观看，把注意力放在环境音的变化上。",
      },
    ],
  },
  {
    id: "independent-cinema-return",
    title: "老影院的新生：独立放映空间正在回暖",
    date: "2026-09-11",
    category: "行业观察",
    author: "周未",
    summary:
      "过去两年，多个城市出现了以小厅、主题排片为特色的放映空间。它们不追求票房，而是靠稳定的策展和社群维系观众。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20a%20restored%20nineteen%20nineties%20cinema%20marquee%20at%20night%20glowing%20amber%20against%20a%20dark%20street%2C%20nostalgic%20mood%2C%20no%20text&width=800&height=500&seq=news-marquee&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "大型影院的银幕越来越多，小厅却在悄悄回来。这些空间通常只有五六十个座位，排片以主题策展为主，一周只放几场，但上座率稳定。",
      },
      { type: "h2", text: "靠策展而不是靠新片" },
      {
        type: "p",
        text: "和商业影院不同，独立放映空间的核心竞争力是「选片逻辑」。一位经营者的说法很直接：观众来这里不是因为没得选，而是因为相信你的品味。",
      },
      {
        type: "quote",
        text: "我们卖的不是两个小时，是一次经过挑选的体验。",
      },
      {
        type: "p",
        text: "这也解释了为什么修复老片、做导演专题在小厅里格外受欢迎。观众愿意为「看不懂但想看明白」的作品买单，映后谈的参与度往往超过预期。",
      },
      { type: "h2", text: "社群比流量更重要" },
      {
        type: "p",
        text: "多数空间的观众来源并非线上投放，而是固定的社群。有人一年来了三十次，也有人只是路过。经营者要做的，是让这两种人都觉得自在。",
      },
    ],
  },
  {
    id: "art-director-interview",
    title: "幕后：一位美术指导如何搭建九十年代的房间",
    date: "2026-08-30",
    category: "幕后访谈",
    author: "陈默",
    summary:
      "从墙纸的花纹到台灯的色温，一个房间的可信度决定了观众是否愿意相信故事。我们和一位从业二十余年的美术指导聊了聊他的工作方法。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20a%20director%20clapperboard%20and%20a%20cup%20of%20coffee%20on%20a%20film%20set%2C%20warm%20tungsten%20light%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=800&height=500&seq=news-clapperboard&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "「观众不会记得你的墙纸是什么花色，但他们一定知道这个房间对不对。」这是采访开始后他说的第一句话。",
      },
      { type: "h2", text: "先定光源，再定家具" },
      {
        type: "p",
        text: "很多人以为美术从家具开始，其实他从灯开始。房间的光源位置决定了摄影机的走位，也决定了演员站哪里最好看。灯定下来，家具的尺寸和颜色才有依据。",
      },
      {
        type: "p",
        text: "他常用的一种做法是：主灯只用一盏，其余全部靠反射。这样画面会有明确的明暗分区，观众的眼睛自然会被带到需要看的地方。",
      },
      {
        type: "quote",
        text: "预算不够的时候，就把钱花在镜头能看到的那一平米上。",
      },
      { type: "h2", text: "细节要做旧，但不能做脏" },
      {
        type: "p",
        text: "年代感来自使用痕迹，而不是灰尘。桌角的磨损、门把手的包浆、窗帘下摆的褪色，这些细节需要被安排，而不是随便弄旧。",
      },
      {
        type: "p",
        text: "最后他提到一件小事：拍摄结束后，他会把布置好的房间拍一张照片留档。「因为那种氛围只存在一次，重搭也搭不回来。」",
      },
    ],
  },
  {
    id: "restoration-notes",
    title: "胶片与数字之间：修复团队的工作笔记",
    date: "2026-08-21",
    category: "专题报道",
    author: "顾南",
    summary:
      "一部老片的修复要经过清洗、扫描、校色、去噪、声音重建五道工序。我们拿到了某修复项目的内部工作笔记，看看一部影片是如何被「救回来」的。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20a%20vintage%20projector%20beam%20cutting%20through%20dark%20theater%20haze%2C%20warm%20light%20and%20dust%20particles%2C%20no%20text&width=800&height=500&seq=news-projector-beam&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "修复不是把画面变漂亮，而是把它变回原来的样子。这句话几乎写在每个修复项目的立项书第一页。",
      },
      { type: "h2", text: "第一步：清洗" },
      {
        type: "p",
        text: "底片在仓库里存放多年，表面会附着霉斑和油污。清洗必须用专门的设备逐格处理，力度过大会伤到乳剂层，过小又清不干净。",
      },
      { type: "h2", text: "第二步：扫描" },
      {
        type: "p",
        text: "扫描分辨率通常选择 4K，为后续处理留出余量。团队会同时扫描多份拷贝，遇到断裂或缺失的片段时相互补足。",
      },
      { type: "h2", text: "第三步：校色" },
      {
        type: "p",
        text: "最耗时的环节。校色师需要参考当年的剧照、拷贝和摄影笔记，判断哪一个版本更接近现场。这里没有绝对标准，只有不断权衡。",
      },
      {
        type: "quote",
        text: "我们经常争论一整天才决定一个镜头的色温，而观众可能根本看不出来。",
      },
      { type: "h2", text: "第四、五步：去噪与声音" },
      {
        type: "p",
        text: "去噪要克制，胶片颗粒本身是影像质感的一部分。声音重建则更麻烦，很多老片的光学声轨已经严重失真，需要重新分离对白、音效与配乐。",
      },
      {
        type: "p",
        text: "一个完整的修复周期通常在十二到十八个月之间。对团队来说，最有成就感的时刻，是导演或摄影师在放映厅里说一句：对了，就是这样。",
      },
    ],
  },
  {
    id: "why-city-night",
    title: "城市夜色为何迷人：谈霓虹美学的影像语言",
    date: "2026-08-09",
    category: "影像随笔",
    author: "沈迟",
    summary:
      "霓虹灯不只是背景，它可以是情绪、是时间，也可以是人物关系的隐喻。这篇随笔从几个具体镜头出发，聊聊夜色为何总能让人物变得立体。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20landscape%20still%20of%20vintage%20film%20posters%20on%20a%20brick%20wall%20with%20peeling%20paper%20texture%20and%20warm%20raking%20light%2C%20no%20text&width=800&height=500&seq=news-old-posters&orientation=landscape",
    blocks: [
      {
        type: "p",
        text: "白天谈事，夜晚谈心。这几乎是所有类型片共享的默认设定。夜色把城市的细节藏起来，也让人的表情变得模糊，观众因此更愿意相信那些平时不会说出口的话。",
      },
      { type: "h2", text: "霓虹是一种会移动的光" },
      {
        type: "p",
        text: "和固定的路灯不同，霓虹会闪、会变色、会被雨水打散。人物走过招牌下面，脸上的颜色每一秒都在变。这种不稳定性，恰好对应了角色内心的摇摆。",
      },
      {
        type: "quote",
        text: "在夜里，人的轮廓是借来的，颜色也是借来的。",
      },
      { type: "h2", text: "湿路面是第二块银幕" },
      {
        type: "p",
        text: "下雨之后的街道会变成一面低分辨率的镜子。摄影师喜欢它，因为可以在同一个画面里同时呈现人物和他的倒影，为叙事提供第二层信息。",
      },
      {
        type: "p",
        text: "更进一步的做法是把倒影拍得比人物更清楚。观众会下意识地盯着水面看，而真正的动作发生在画面边缘——这是一种非常经济的悬念手法。",
      },
      { type: "h2", text: "为什么紫色总在夜里出现" },
      {
        type: "p",
        text: "紫色在低照度环境下更容易保留层次，同时它与肤色的对比足够明显，不会让人物糊进背景。这是技术与审美的双重选择，也是这类影片视觉辨识度的重要来源。",
      },
      {
        type: "p",
        text: "所以当我们说一部片子「很有夜的味道」，说的往往是它在光线上的判断，而不仅仅是它拍了晚上。",
      },
    ],
  },
];